import React from "react";

function PageLoader() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center bg-[#f9f9f9]">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-green-500 border-t-transparent" />
    </div>
  );
}

export default PageLoader;
